import type { LogoBarProps as Props } from './types';
import { cls } from '@/utils/cls';
import style from './LogoBar.module.scss';
import Image from 'next/image';
export default function LogoBar({
  extendStyles,
  heading,
  logos
}: Props) {
  const _className = cls(style.root, extendStyles);
  const hasLogos = !!logos && logos.length > 0;
  return <aside className={_className} data-sentry-component="LogoBar" data-sentry-source-file="LogoBar.tsx">
			<div data-grid>
				<div className={style.content}>
					{heading && <h3 className={style.copy}>{heading}</h3>}
					<div className={style.logos}>
						{hasLogos && logos.map(({
            logo,
            link
          }) => {
            if (!logo?.value?.data?.image) return null;
            return link ? <a target="_blank" rel="noopener noreferrer" href={link} key={`logo-image-${logo.value.data.name}`}>
										<Image priority src={logo.value.data.image} alt={logo.value.data.name ?? ''} role={logo.value.data.name ? undefined : 'presentation'} width={130} height={50} />
									</a> : <Image priority key={`logo-image-${logo.value.data.name}`} src={logo.value.data.image} alt={logo.value.data.name ?? ''} role={logo.value.data.name ? undefined : 'presentation'} width={130} height={50} />;
          })}
					</div>
				</div>
			</div>
		</aside>;
}